import { BlogManagerArticleDTO } from "@/common/api/models/BlogManagerArticleDTO";

export enum STATUS {
  EDIT = "edit",
  WAIT = "wait",
  OPEN = "open",
  DELETE = "z_delete",
}

export const STATUS_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAIT]: "公開待ち",
  [STATUS.OPEN]: "公開中",
  [STATUS.DELETE]: "削除",
};

export const STATUS_NAME_INPUT = {
  [STATUS.EDIT]: "編集中",
  [STATUS.OPEN]: "公開",
  [STATUS.DELETE]: "削除",
};

export const STATUS_CSS = {
  [STATUS.EDIT]: "editing",
  [STATUS.WAIT]: "wait",
  [STATUS.OPEN]: "release",
  [STATUS.DELETE]: "delete",
};

export const STATUS_ARRAY = [
  { id: STATUS.EDIT, name: STATUS_NAME[STATUS.EDIT] },
  { id: STATUS.WAIT, name: STATUS_NAME[STATUS.WAIT] },
  { id: STATUS.OPEN, name: STATUS_NAME[STATUS.OPEN] },
  { id: STATUS.DELETE, name: STATUS_NAME[STATUS.DELETE] },
];

export const STATUS_ARRAY_INPUT = [
  { id: STATUS.EDIT, name: STATUS_NAME_INPUT[STATUS.EDIT] },
  { id: STATUS.OPEN, name: STATUS_NAME_INPUT[STATUS.OPEN] },
  { id: STATUS.DELETE, name: STATUS_NAME_INPUT[STATUS.DELETE] },
];

export enum SETTING {
  NOW = "now",
  DATE = "date",
}

export const SETTING_NAME = {
  [SETTING.NOW]: "今すぐ公開",
  [SETTING.DATE]: "日時指定",
};

export default class Article {
  id?: number;
  group_id: number;
  title: string;
  context: string;
  post_date: string;
  open_satatus: any;
  release_setting: any;
  created_at: string;
  images: any;
  tags: any;
  post_groups: any;
  user_created: any;
  article_page_views: any;
  article_likes: any;
  constructor(dto?: BlogManagerArticleDTO) {
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      group_id: null,
      title: null,
      context: null,
      post_date: null,
      open_satatus: STATUS.EDIT,
      release_setting: SETTING.NOW,
      created_at: null,
      images: [],
      tags: [],
      post_groups: [],
      user_created: null,
      article_page_views: [],
      article_likes: [],
    });
  }

  get tagsNum() {
    return this.tags.length;
  }

  get openSatatusName() {
    return STATUS_NAME[this.open_satatus];
  }

  get settingName() {
    return SETTING_NAME[this.release_setting];
  }
}
